module.exports = __webpack_public_path__ + "static/media/pest-control-articles-blog.770f3e21.jpg";